import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import PublicIcon from '@mui/icons-material/Public';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';
import { buildExplorerPublishedAssetUrl, isAssetPublished } from '../AssetExplorer.api';

export interface PublishedAssetGlobeButtonProps {
    publishedRelativeUrl?: string | null;
    size?: 'small' | 'medium';
    className?: string;
    sx?: SxProps<Theme>;
}

/** Opens the asset CDN publish URL in a new tab; renders nothing if not published. */
export const PublishedAssetGlobeButton: React.FC<PublishedAssetGlobeButtonProps> = ({
    publishedRelativeUrl,
    size = 'small',
    className,
    sx,
}) => {
    const assetsS3CdnUrl = useSelector((state: RootState) => state.clientConfig.data?.assetsS3CdnUrl);

    if (!isAssetPublished({ publishedRelativeUrl })) {
        return null;
    }

    const absoluteUrl = buildExplorerPublishedAssetUrl(assetsS3CdnUrl, publishedRelativeUrl);
    if (!absoluteUrl) {
        return null;
    }

    return (
        <Tooltip title="Open published URL in new tab">
            <IconButton
                size={size}
                className={className}
                aria-label="Open published URL in new tab"
                onClick={(e) => {
                    e.stopPropagation();
                    window.open(absoluteUrl, '_blank', 'noopener,noreferrer');
                }}
                sx={sx}
            >
                <PublicIcon fontSize={size} />
            </IconButton>
        </Tooltip>
    );
};

export default PublishedAssetGlobeButton;
